module.exports = __webpack_public_path__ + "public/a188fcb340322559c4e7f831619ecbb4.woff2";